export const contractToolbarConfig = [
    {
        id: "renameContract",
        titleText: "Rename Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:edit",
        buttonTypeClassName: "default-btn border-right",
        actionName: "RENAME",
    },
    {
        id: "saveContract",
        titleText: "Save Contract sItem",
        textWithIcon: true,
        isIcon: true,
        iconClass: "ion:save-outline",
        buttonTypeClassName: "default-btn border-right",
        actionName: "SAVE",
    },
    {
        id: "closeContract",
        titleText: "Close Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "bx:window-close",
        buttonTypeClassName: "default-btn",
        actionName: "CLOSE",
    },
]

export const contractToolbarDeleteBtnConfig = [
    {
        id: "deleteContract",
        titleText: "Delete Contract",
        textWithIcon: true,
        isIcon: true,
        iconClass: "fluent:delete-24-regular",
        buttonTypeClassName: "default-btn",
        actionName: "DELETE"
    },
]

